import React from "react";
import {
  CommentairesWebBlock,
  DiagnosticSanitaireWebBlock,
  DiagnosticVisuelWebBlock,
} from "../components/WebBlocks";
import type { PrintDataFields } from "../hooks/use-print-data";
import type { ResolvedItem } from "./types";

const WEB_BLOCKS: Record<string, React.FC<{ data: PrintDataFields }>> = {
  bloc_diagnostic_visuel: DiagnosticVisuelWebBlock,
  bloc_diagnostic_sanitaire: DiagnosticSanitaireWebBlock,
  bloc_commentaires: CommentairesWebBlock,
};

/** Rendu réel des blocs riches de la fiche, pour `HtmlPrintTemplate` (l'éditeur, lui, garde des cadres). */
export const renderWebBlock =
  (data: PrintDataFields) => (item: ResolvedItem) => {
    const Block = WEB_BLOCKS[item.key];
    return Block ? <Block data={data} /> : null;
  };
